import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import Form from 'jl-design-system/components/form/Form';
import Message from 'jl-design-system/components/message/Message';
// config
import { guestFormConfig } from '../../utils/form/configs/login';
// components
import RadioButtonTile from '../radio-button-tile/RadioButtonTile';
// styles
import styles from './login-choice.scss';

export class LoginChoice extends PureComponent {
  static propTypes = {
    auth0Failure: PropTypes.bool,
    loginApiCallActive: PropTypes.bool,
    onFormSubmit: PropTypes.func,
    showEmailValidationError: PropTypes.bool,
    showPartnerAppText: PropTypes.bool,
    userEmail: PropTypes.string,
  };

  static defaultProps = {
    auth0Failure: false,
    loginApiCallActive: false,
    onFormSubmit: window.defaultFunc,
    showEmailValidationError: false,
    showPartnerAppText: false,
    userEmail: '',
  };

  static getLabel({ label, labelExtra }) {
    return (
      <>
        <span data-test="radio-field-label">{label}</span>
        <span data-test="radio-field-label-extra">{labelExtra}</span>
      </>
    );
  }


  getGuestChoice = () => {
    const {
      loginApiCallActive,
      onFormSubmit,
      showPartnerAppText,
      showEmailValidationError,
      userEmail,
      auth0Failure,
    } = this.props;

    const guestConfig = guestFormConfig(showPartnerAppText);
    const guestLabel = LoginChoice.getLabel({
      label: 'Guest checkout',
      labelExtra: !auth0Failure ? 'You can create an account later' : '',
    });

    return (
      <RadioButtonTile
        id="guest:true"
        label={guestLabel}
        name="guest"
        value="guest:true"
      >
        {
          showEmailValidationError &&
          <Message
            animation="shake"
            title="Please make sure your email format is correct"
            type="error"
          />
        }

        <Form
          config={guestConfig}
          data-test="register-form"
          destroyOnUnmount={false}
          form={guestConfig.id}
          initialValues={{ email: userEmail }}
          onSubmit={onFormSubmit}
          submittingOverride={loginApiCallActive}
        />
      </RadioButtonTile>
    );
  }

  render() {
    return (
      <div className={styles.container} data-test="login-choice-new">
        { this.getGuestChoice() }
      </div>
    );
  }
}

export default LoginChoice;
